export enum NumLock {
  Default = "default",
  With = "with",
  Without = "without",
}
